<template>
  <div class="sources-list">
    <div v-if="!sources || !sources.length" class="sources-empty">
      <span class="sources-empty-text">No feeds yet</span>
    </div>
    <div v-else class="sources-items">
      <router-link
        v-for="source of sources"
        :key="source.name"
        :to="`/sources/${source.name}`"
        class="source-link"
        :class="{ 'is-active': isActive(source.name) }"
        :title="displayName(source)"
        v-tooltip.right="{ value: displayName(source), disabled: !compact }"
      >
        <span class="source-logo" aria-hidden="true">
          <img
            v-if="logoFor(source)"
            :src="logoFor(source).src"
            :alt="logoFor(source).label"
            width="20"
            height="20"
          />
          <i v-else class="pi pi-database source-icon-fallback" />
        </span>
        <span class="source-meta">
          <span class="source-name">{{ displayName(source) }}</span>
          <span v-if="!compact && source.name !== displayKey(source)" class="source-key">{{ source.name }}</span>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { sourceLogo, sourceDisplayName, platformKey } from '../lib/sourceLogos'

export default {
  props: {
    sources: Array,
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isActive(name) {
      return this.$route.path === `/sources/${name}`
    },
    logoFor(source) {
      return sourceLogo(source)
    },
    displayName(source) {
      return sourceDisplayName(source)
    },
    displayKey(source) {
      return platformKey(source) || source.name
    },
  },
}
</script>

<style scoped>
.sources-empty {
  padding: 0.4rem 0.55rem;
  font-size: 0.75rem;
  color: var(--bk-muted);
}

.sources-items {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.source-link {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.4rem 0.45rem;
  border-radius: 8px;
  text-decoration: none;
  color: var(--bk-ink);
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.source-link:hover {
  background: #fff;
  border-color: var(--bk-line);
}

.source-link.is-active {
  background: #fff;
  border-color: var(--bk-line-strong);
  box-shadow: var(--bk-shadow);
}

.source-logo {
  flex-shrink: 0;
  width: 1.35rem;
  height: 1.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(24, 24, 27, 0.08);
}

.source-logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.source-icon-fallback {
  font-size: 0.75rem;
  opacity: 0.55;
}

.source-meta {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.source-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  transition: opacity 0.18s ease;
}

.source-key {
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--bk-muted);
  letter-spacing: 0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
